// extracted by mini-css-extract-plugin
module.exports = {"invalidInput":"SettingsModal_invalidInput__1SrP1"};